var workerStatsByArg = {};
var workerStats = {};
import { deepClone } from '@/modules/mm-utils';
export default {
  set: function set(key1, key2, value) {
    if (!workerStatsByArg[key1]) workerStatsByArg[key1] = {};
    workerStatsByArg[key1][key2] = deepClone(value);
  },
  setByWorkerId: function setByWorkerId(workerId, value) {
    workerStats[workerId] = value;
  },
  get: function get(key1) {
    return deepClone(workerStatsByArg[key1]);
  },
  getByWorkerId: function getByWorkerId(workerId) {
    return workerStats[workerId];
  },
  purge: function purge(keyName) {
    delete workerStatsByArg[keyName];
  },
  log: function log() {
    console.log(workerStats);
  }
};